export default __webpack_public_path__ + "static/media/back_arrow.56fd18e5.svg";